module.exports = __webpack_public_path__ + "img/seccion2.1_fotos.8de5676c.png";